$(document).ready(function () {
    
    $(".login-btn").click(function () {
        event.preventDefault();

        var honeypot = $('#honeypot').val();

        if(!honeypot){

            $('.authorization .required').each(inputCheck);

            if($('.error').length == 0){
                loader_on();
                // Получаем данные с формы
                var $login_phone      = $("#login_phone").val();
                    $login_password   = $("#login_password").val(); 

                $.post('/wp-admin/admin-ajax.php', {
                    action: 'login_dashboard',
                    login_phone: $login_phone,
                    login_password: $login_password,
                },
                
                    function (res) {
                        loader_off();

                        var $json = JSON.parse(res);
                        
                        if($json.result == 'success'){                   
                            if( $('body').hasClass('page-template-login') ){
                                // При авторизации редиректим в Личный кабинет
                                window.location.href = '/dashboard';
                            }else{
                                // При авторизации редиректим
                                location.reload();
                            }
                        }else{
                            displayErrors($json.text_error);
                        }

                    }

                );

            }

        }

    });

});